import { UIKitIcon } from '../icon';

export const filterIcon: UIKitIcon = {
  name: 'filter',
  // tslint:disable-next-line: max-line-length
  data: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="32" viewBox="0 0 32 32">'
  + '<g><line x2="12" transform="translate(10 12)" fill="none" stroke="inherit" stroke-miterlimit="10" stroke-width="1"/><line x2="8"'
  + ' transform="translate(12 16)" fill="none" stroke="inherit" stroke-miterlimit="10" stroke-width="1"/><line x2="4" '
  + 'transform="translate(14 20)" fill="none" stroke="inherit" stroke-miterlimit="10" stroke-width="1"/></g></svg>',
};
